export const constants = {
  commentDisclaimer:
    'Kommentarer vil leses av fagsjefer, ledere og administratorer. Derfor skal ikke evalueringen inneholde informasjon om navngitte personer, men leverandørens evne til å levere en vare og/eller tjeneste.',
};
